/* V13: looping five-second announcements inside the native sticky header. */
(() => {
  class MedBenefitRotator extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.messages = [...this.querySelectorAll('[data-med-benefit]')];
      if (this.messages.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelectorAll('.med-benefit-arrow').forEach(button => { button.hidden = false; });
      this.setAttribute('data-ready', '');
      this.querySelector('[data-med-benefit-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-med-benefit-next]').addEventListener('click', () => this.move(1), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.onMotionChange = () => this.schedule();
      this.motion.addEventListener('change', this.onMotionChange);
      this.show();
      this.schedule();
    }
    show() { this.messages.forEach((message, i) => { message.hidden = i !== this.index; }); }
    move(direction) {
      this.index = (this.index + direction + this.messages.length) % this.messages.length;
      this.show();
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.motion.matches || document.hidden) return;
      this.timer = setTimeout(() => this.move(1), 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  }
  if (!customElements.get('med-benefit-rotator')) customElements.define('med-benefit-rotator', MedBenefitRotator);
})();
